import * as React from "react";
import {
  Box,
  Grid,
  Link,
  TextField,
  Typography,
  IconButton,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { ImagesContext } from "../Context";

interface DiagnosisCodesProps {
  diagnosisCodes: { code: string }[];
  onChange: (index: number, value: string) => void;
  onAdd: () => void;
  onRemove: (index: number) => void;
  totalDiagnosisCodes: number;
  claimStatus: string;
}

const DiagnosisCodes = ({
  diagnosisCodes,
  onChange,
  onAdd,
  onRemove,
  totalDiagnosisCodes,
  claimStatus,
}: DiagnosisCodesProps) => {
  const images = React.useContext(ImagesContext);
  const chargeDiagnosisCodes = diagnosisCodes?.length;

  return (
    <Box>
      <Box display="flex" alignItems="center" columnGap="5px">
        <Typography
          sx={{
            color: "#A29D9B",
            fontWeight: 700,
            fontSize: "12px",
            lineHeight: "26px",
          }}
        >
          More Diagnosis Codes
        </Typography>
        {totalDiagnosisCodes < 8 &&
          chargeDiagnosisCodes > 0 &&
          chargeDiagnosisCodes < 3 &&
          claimStatus !== "submitted" &&
          claimStatus !== "pending_submission" && (
            <IconButton onClick={onAdd} size="small" sx={{ padding: "0px" }}>
              <img
                src={images.add_icon}
                alt="Add Diagnosis Code"
                className="action-icon-image"
                style={{ width: 12, height: 12 }}
              />
            </IconButton>
          )}
      </Box>

      {chargeDiagnosisCodes === 0 ? (
        <>
          <p
            style={{
              color: "#707070",
              fontWeight: 400,
              fontSize: "10px",
              lineHeight: "14px",
              marginBlockStart: "0px",
              marginBlockEnd: "0px",
              marginBottom: "5px",
            }}
          >
            Sometimes multiple diagnosis codes are required for comprehensive
            reporting. <b>This is uncommon.</b>
          </p>
          {totalDiagnosisCodes < 8 &&
            claimStatus !== "submitted" &&
            claimStatus !== "pending_submission" && (
              <Link
                sx={{
                  fontSize: "10px",
                  lineHeight: "14px",
                  textDecoration: "underline",
                  color: "#3F51B5",
                }}
                onClick={onAdd}
              >
                I need more diagnosis codes
              </Link>
            )}
        </>
      ) : (
        <Grid container spacing={1}>
          {diagnosisCodes?.map((diagnosisCode, i) => (
            <Grid item xs={6} key={`diagnosis-${i + 2}`}>
              <Box
                display="flex"
                alignItems="center"
                sx={{
                  backgroundColor: "#e5e0de",
                  paddingLeft: "10px",
                  paddingRight: "10px",
                  borderRadius: "5px",
                }}
              >
                <Typography
                  sx={{
                    fontSize: "12px",
                    lineHeight: "20px",
                    fontWeight: 500,
                    color: "#707070",
                  }}
                >
                  {i + 2}.
                </Typography>
                <Box className="field-container" sx={{ marginLeft: "0px" }}>
                  <TextField
                    size="small"
                    value={diagnosisCode.code}
                    className="the-field"
                    required
                    variant="outlined"
                    placeholder="XXXXXXX"
                    disabled={
                      claimStatus === "submitted" ||
                      claimStatus === "pending_submission"
                    }
                    onChange={(e) => onChange(i + 1, e.target.value)}
                    sx={{
                      width: "100% !important",
                    }}
                    InputProps={{
                      sx: {
                        "& input": {
                          paddingRight: "3px !important",
                          paddingLeft: "3px !important",
                          fontSize: "12px",
                          fontWeight: 500,
                          color: "#707070",
                        },
                      },
                    }}
                    slotProps={{
                      htmlInput: {
                        maxLength: 7,
                      },
                    }}
                  />
                </Box>
                <IconButton
                  onClick={() => onRemove(i + 1)}
                  size="small"
                  sx={{
                    padding: "0px",
                    height: "7px",
                    width: "7px",
                  }}
                >
                  <CloseIcon
                    fontSize="inherit"
                    sx={{ height: "12px", width: "12px" }}
                  />
                </IconButton>
              </Box>
            </Grid>
          ))}
        </Grid>
      )}
    </Box>
  );
};

export default DiagnosisCodes;
